import React, { useEffect, useState } from "react";
import axios from "axios";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Power.css";

const Dashboard = () => {
  const [embedConfig, setEmbedConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [report, setReport] = useState(null);

  const embedUrl = process.env.REACT_APP_POWERBI_EMBED_URL;
  const reportId = process.env.REACT_APP_POWERBI_REPORT_ID;

  useEffect(() => {
    const fetchEmbedToken = async () => {
      try {
        const response = await toast.promise(
          axios.get(`${process.env.REACT_APP_BE_MAIN_URL}/ocr/powerbi/`),
          {
            pending: "Fetching Power BI token...",
            success: "Token fetched successfully",
            error: "Failed to fetch token",
          }
        );

        const { embedToken } = response.data;

        setEmbedConfig({
          type: "report",
          embedUrl,
          id: reportId,
          accessToken: embedToken,
          tokenType: models.TokenType.Embed,
          settings: {
            panes: {
              filters: { expanded: false, visible: false },
              pageNavigation: { visible: true },
            },
            background: models.BackgroundType.Transparent,
            navContentPaneEnabled: false,
          },
        });
      } catch (error) {
        console.error("Failed to fetch Power BI token", error);
      }
    };

    fetchEmbedToken();
    const interval = setInterval(fetchEmbedToken, 55 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-white flex-1 rounded-lg shadow-md flex relative">
      <ToastContainer />
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-10">
          <div className="text-lg font-semibold text-gray-700">Loading Report...</div>
        </div>
      )}
      {embedConfig && (
        <PowerBIEmbed
          embedConfig={embedConfig}
          eventHandlers={new Map([
            ["loaded", () => console.log("Report loaded")],
            ["rendered", () => setIsLoading(false)],
            ["error", (event) => console.error("Power BI error", event.detail)],
          ])}
          cssClassName="Embed-container"
          getEmbeddedComponent={async (embeddedReport) => {
            setReport(embeddedReport);
          }}
        />
      )}
    </div>
  );
};

export default Dashboard;
